import type { CSSProperties } from "react";

export const mono = "'Courier New', monospace";

export const s: Record<string, CSSProperties> = {
  slip: { border: "1px solid #000", position: "relative", padding: "6px 8px 7px 20px" },
  vprot: { position: "absolute", left: 0, top: 0, bottom: 0, width: 16, borderRight: "1px solid #000", writingMode: "vertical-rl", transform: "rotate(180deg)", textAlign: "center", fontSize: 7.5, padding: "6px 2px", display: "flex", flexDirection: "column", justifyContent: "space-between" },
  topband: { display: "flex", gap: 0, alignItems: "stretch", marginBottom: 3 },
  empbox: { border: "1px solid #000", padding: "4px 8px", flex: "0 0 38%", minHeight: 44 },
  cap: { fontSize: 7, lineHeight: 1.15, marginBottom: 4 },
  empAddr: { fontFamily: mono, fontSize: 10.5, lineHeight: 1.35 },
  cracell: { flex: "0 0 32%", textAlign: "left", fontSize: 8.5, lineHeight: 1.2, padding: "2px 6px 4px", borderBottom: "1.5px solid #000" },
  crarow1: { display: "flex", gap: 5, alignItems: "flex-start" },
  flag: { flex: "0 0 auto", display: "inline-flex", width: 32, height: 17, border: "0.5px solid #999", background: "linear-gradient(to right,#000 25%,#fff 25%,#fff 75%,#000 75%)", alignItems: "center", justifyContent: "center", overflow: "hidden" },
  leaf: { fontSize: 14, lineHeight: 1, filter: "grayscale(1) brightness(0)" },
  craname: { display: "flex", gap: 9, fontSize: 8, lineHeight: 1.25 },
  cranameSpan: { width: 54, display: "inline-block" },
  crarow2: { display: "flex", gap: 8, alignItems: "center", marginTop: 3 },
  yrlbl: { fontSize: 7, lineHeight: 1.1 },
  yrbox: { border: "1px solid #000", display: "inline-block", padding: "2px 12px", fontSize: 12, fontFamily: mono },
  t4title: { flex: 1, textAlign: "right", padding: "2px 0 4px", borderBottom: "1.5px solid #000" },
  t4: { fontSize: 20, fontWeight: "bold" },
  st: { fontSize: 10, fontWeight: "bold" },
  bodyrow: { display: "flex", gap: 3, alignItems: "stretch" },
  leftcol: { flex: "0 0 40%", display: "flex", flexDirection: "column", gap: 2 },
  midcol: { flex: "0 0 15%", display: "flex", flexDirection: "column", gap: 2 },
  rightcol: { flex: 1, display: "flex", flexDirection: "column", gap: 2 },
  mbox: { display: "flex", flexDirection: "column" },
  mlabel: { textAlign: "center", fontSize: 6.5, lineHeight: 1.05, padding: "1px 2px 0", minHeight: 13, display: "flex", alignItems: "flex-end", justifyContent: "center" },
  mfield: { border: "1px solid #000", display: "flex", alignItems: "stretch", minHeight: 20 },
  mnum: { borderRight: "1px solid #000", fontWeight: "bold", fontSize: 8, padding: "1px 3px", display: "flex", alignItems: "flex-start" },
  mval: { flex: 1, textAlign: "right", fontFamily: mono, fontSize: 11, padding: "1px 4px", display: "flex", alignItems: "center", justifyContent: "flex-end" },
  mcents: { borderLeft: "1px solid #000", width: 22, textAlign: "right", fontFamily: mono, fontSize: 11, padding: "1px 3px", display: "flex", alignItems: "center", justifyContent: "flex-end" },
  tval: { flex: 1, fontFamily: mono, fontSize: 11, padding: "1px 6px", display: "flex", alignItems: "center" },
  mrow: { display: "flex", gap: 3 },
  box54: { border: "1px solid #000", display: "flex", alignItems: "stretch", minHeight: 28 },
  box54n: { borderRight: "1px solid #000", fontWeight: "bold", fontSize: 8.5, padding: "2px 5px", display: "flex", alignItems: "flex-start" },
  box54b: { flex: 1, padding: "2px 7px" },
  box54l: { fontSize: 6.5 },
  box54v: { fontFamily: mono, fontSize: 12, letterSpacing: 1, marginTop: 2 },
  lrow: { display: "flex", gap: 3 },
  exf: { border: "1px solid #000", display: "flex", alignItems: "stretch", minHeight: 32 },
  exfn: { borderRight: "1px solid #000", fontWeight: "bold", fontSize: 8.5, padding: "2px 3px", display: "flex", alignItems: "flex-start" },
  excols: { flex: 1, display: "flex", justifyContent: "space-around", alignItems: "center", textAlign: "center", fontSize: 6, padding: "2px 0" },
  cbx: { border: "1px solid #000", width: 14, height: 11, margin: "2px auto" },
  empname: { border: "1px solid #000", padding: "4px 7px", flex: 1, minHeight: 78, position: "relative" },
  nhdr: { fontSize: 6.5, display: "flex", justifyContent: "space-between", margin: "3px 0" },
  nameline: { border: "1px solid #000", display: "flex", padding: "3px 6px", fontFamily: mono, fontSize: 12, position: "relative" },
  arw: { position: "absolute", left: -11, top: 4, fontSize: 11 },
  ln: { flex: 1 },
  fn: { flex: "0 0 34%" },
  inch: { flex: "0 0 8%", textAlign: "right" },
  addr: { fontFamily: mono, fontSize: 11, marginTop: 10, lineHeight: 1.8 },
  other: { border: "1px solid #000", marginTop: 6, padding: "5px 8px" },
  orow: { display: "flex", gap: 6, marginTop: 3 },
  ocell: { flex: 1, display: "flex", flexDirection: "column" },
  och: { display: "flex", fontSize: 6.5 },
  ochA: { flex: 1, textAlign: "center" },
  ocf: { display: "flex", marginTop: 1 },
  obc: { border: "1px solid #000", width: 34, height: 18 },
  oam: { border: "1px solid #000", borderLeft: "none", flex: 1, height: 18 },
  sfoot: { display: "flex", justifyContent: "space-between", marginTop: 6, fontSize: 8.5 },

  rev: { fontSize: 8.5, lineHeight: 1.3 },
  revH: { fontSize: 11, fontWeight: "bold", margin: "4px 0 5px" },
  rtwo: { display: "flex", gap: 22 },
  rc: { flex: 1 },
  ritem: { marginBottom: 4 },
  rbox: { border: "1px solid #000", padding: "5px 7px", margin: "5px 0", display: "flex", justifyContent: "space-between", gap: 10 },
  rl: { flex: 1 },
  rr: { width: 150 },
  donot: { border: "1px solid #000", padding: "7px 9px", marginTop: 8 },
  dcols: { display: "flex", gap: 18, marginTop: 5 },
  dc: { flex: 1 },
  rfoot: { display: "flex", justifyContent: "space-between", fontSize: 8, marginTop: 6 },
};